/* tslint:disable */
import {
  Partner,
  CrmCaseStage,
  Company,
  ClaimLine
} from '../index';

declare var Object: any;
export interface CrmClaimInterface {
  "id"?: number;
  "name"?: string;
  "active"?: boolean;
  "picking_org_id"?: number;
  "gallery_id"?: number;
  "partner_id"?: number;
  "stage_id"?: number;
  "company_id"?: number;
  "claim_line_ids"?: Array<any>;
  partner?: Partner;
  stage?: CrmCaseStage;
  company?: Company;
  lines?: ClaimLine[];
}

export class CrmClaim implements CrmClaimInterface {
  "id": number;
  "name": string;
  "active": boolean;
  "picking_org_id": number;
  "gallery_id": number;
  "partner_id": number;
  "stage_id": number;
  "company_id": number;
  "claim_line_ids": Array<any>;
  partner: Partner;
  stage: CrmCaseStage;
  company: Company;
  lines: ClaimLine[];
  constructor(data?: CrmClaimInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CrmClaim`.
   */
  public static getModelName() {
    return "CrmClaim";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CrmClaim for dynamic purposes.
  **/
  public static factory(data: CrmClaimInterface): CrmClaim{
    return new CrmClaim(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CrmClaim',
      plural: 'CrmClaims',
      path: 'CrmClaims',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean'
        },
        "picking_org_id": {
          name: 'picking_org_id',
          type: 'number'
        },
        "gallery_id": {
          name: 'gallery_id',
          type: 'number'
        },
        "partner_id": {
          name: 'partner_id',
          type: 'number'
        },
        "stage_id": {
          name: 'stage_id',
          type: 'number'
        },
        "company_id": {
          name: 'company_id',
          type: 'number'
        },
        "claim_line_ids": {
          name: 'claim_line_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
      },
      relations: {
        partner: {
          name: 'partner',
          type: 'Partner',
          model: 'Partner',
          relationType: 'belongsTo',
                  keyFrom: 'partner_id',
          keyTo: 'id'
        },
        stage: {
          name: 'stage',
          type: 'CrmCaseStage',
          model: 'CrmCaseStage',
          relationType: 'belongsTo',
                  keyFrom: 'stage_id',
          keyTo: 'id'
        },
        company: {
          name: 'company',
          type: 'Company',
          model: 'Company',
          relationType: 'belongsTo',
                  keyFrom: 'company_id',
          keyTo: 'id'
        },
        lines: {
          name: 'lines',
          type: 'ClaimLine[]',
          model: 'ClaimLine',
          relationType: 'referencesMany',
                  keyFrom: 'claim_line_ids',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/CrmClaim.ts